import { render } from "./list-toolbar.vue?vue&type=template&id=2e897dac"
import script from "./list-toolbar.vue?vue&type=script&lang=js"
export * from "./list-toolbar.vue?vue&type=script&lang=js"
script.render = render

export default script